

jQuery(document).ready(function() {


	console.log("hello ADA ");
	

      	jQuery('.kit-swatch img').attr("alt","");
        jQuery('.tpo_quantity-selector_input').attr("aria-label","Quantity");
        jQuery('.commentsUser input').removeAttr("placeholder");
        jQuery('.commentsUser textarea').removeAttr("placeholder");

        // alt texts for icons under product thumnail in product page. 

        
	        jQuery('img[src*="/Flexible_4.png?v=1753454086"]').attr('alt', 'Flexible');
	        jQuery('img[src*="/Durable_3.png?v=1753454079"]').attr('alt', 'Durable');
	        jQuery('img[src*="/Mixable.png?v=1753454073"]').attr('alt', 'Mixable');
	        jQuery('img[src*="/Flag_f323fcd6-00ab-4144-8ce8-f932a86b76de.png?v=1753457829"]').attr('alt', 'Made in USA');
      
	        jQuery('img[src*="/Permanent_3.png?v=1753456305"]').attr('alt', 'Permanant Results');
	        jQuery('img[src*="/Permanent_2.png?v=1753454129"]').attr('alt', 'Permanant Results');
	        jQuery('img[src*="/Vibrant_2.png?v=1753454140"]').attr('alt', 'Vibrant Colors');
	        jQuery('img[src*="/Deep_Penetration_3.png?v=1753454133"]').attr('alt', 'Deep Penetration');
	        jQuery('img[src*="/Low_VOC_2.png?v=1753454151"]').attr('alt', 'Low VOC');
    
	        jQuery('img[src*="/Shipping_49.png?v=1758818988"]').attr('alt', 'Free US Shipping Over $49');
	        jQuery('img[src*="/Customer_Service_4.png?v=1753424013"]').attr('alt', 'Live Customer Service');
	        jQuery('img[src*="/Reviews_6.png?v=1753469524"]').attr('alt', '40 thounsand plus 5 star reviews');
	        jQuery('img[src*="/100_4.png?v=1753424019"]').attr('alt', 'Years of Business');
	        jQuery('img[src*="/Trusted.png?v=1753454157"]').attr('alt', 'Trusted Formula');

	       


          



                $('#shopify-section-template--19364343087170__banner_ECHzi9 h1').each(function () {
                $(this).replaceWith(
                    $('<h2>', {
                        class: this.className,
                        html: $(this).html()
                    })
                );
                });

                $('#shopify-section-template--19364342661186__logo_list_pMppAK p').each(function () {
                $(this).replaceWith(
                    $('<h2>', {
                        class: this.className,
                        html: $(this).html()
                    })
                );
                });

                jQuery(function ($) {
                  function replaceHeading() {
                      $('.mbc-bundles-list__title').each(function () {
                          if ($(this).is('h3')) {
                              $(this).replaceWith($('<h2>', {
                                  class: this.className,
                                  html: $(this).html()
                              }));
                          }
                      });
                  }

                  replaceHeading();

                  new MutationObserver(replaceHeading).observe(document.body, {
                      childList: true,
                      subtree: true
                  });
                });

 
      

                

                // Heading change for homepage
                $(
                    '#shopify-section-template--19364343087170__product_slider_L4iAAC h3,' +
                    '.testimonial-header,' +
                    '#shopify-section-template--19364343087170__ca2883b6-efd0-48c1-8f9e-520a6b9a64bc .max-w-prose.md\\:w-auto.w-full h3,' +
                    '#shopify-section-template--19364343087170__f8adb439-139f-4a65-93f4-6f566485114e .max-w-prose.md\\:w-auto.w-full h3,' +
                    '#shopify-section-template--19364343087170__content_slider_LX8E8k .max-w-prose.md\\:w-auto.w-full h3,'+
                    '#shopify-section-template--19364343087170__article_grid_hNFci6 .max-w-prose.md\\:w-auto.w-full h3,'+
                    '.shopify-section-group-footer-group h3,'+
                    '.all-content-wrap.grow h3,'+
                    '.mbc-bundles-list__title'
                ).each(function () {
                    $(this).replaceWith(
                        $('<h2>', {
                            class: this.className,
                            html: $(this).html()
                        })
                    );
                });


                


              jQuery(function ($) {

              function updateSelectedState() {

                  $('.product-option-button').attr('aria-selected', 'false');

                  $('.product-option-button.border--focus').attr('aria-selected', 'true');

              }

              updateSelectedState();

              $(document).on('click', '.product-option-button', function () {

                  setTimeout(updateSelectedState, 50);

              });

          });

          jQuery(function($){
              function removeTabindex(){
                  $('.group-hover\\:border__button--focus.btn[tabindex]').removeAttr('tabindex');
              }
              removeTabindex();
              new MutationObserver(function(){
                  removeTabindex();
              }).observe(document.body,{
                  subtree:true,
                  childList:true,
                  attributes:true,
                  attributeFilter:['tabindex']
              });
          });




});

setTimeout(function () {

            jQuery('.shopify-section.shopify-section-group-footer-group')
                .removeAttr('role')
                .last()
                .attr('role', 'contentinfo');

            jQuery('br').attr("aria-hidden","true");
            
            jQuery('.group-hover\\:border__button--focus.btn').removeAttr("tabindex");
            jQuery('.tpo_quantity-selector_input').attr("aria-label","Quantity");
            jQuery('#shopify-section-sections--19364336369730__theme_announcement').attr({'role': 'region','aria-label': 'Shipping promotion announcement' });
            jQuery('nav').attr('role','none');
            jQuery('.jdgm-prev-badge__stars').attr('tabindex','-1');
            jQuery('.card--product-item__content').attr('tabindex','0');
            jQuery('.animation-300.absolute img').attr('aria-hidden','true');
            jQuery('.whitespace-nowrap.md\\:snap-x.scroll-smooth.hidescrollbar.inline-flex.w-full.px-4.overflow-x-auto.overflow-y-hidden.flickity-enabled.is-draggable')
              .removeAttr('tabindex');
            // jQuery('.ada-phone').wrap('<a href="tel:+15623258096"></a>');
            // jQuery('.ada-email').wrap('<a href="mailto:info@angelusdirect.com" aria-label="Send an email info@angelusdirect.com "></a>');

            jQuery('img[src="https://cdn.shopify.com/s/files/1/0228/2629/files/FedexAccount_grande.jpg?12533"]').attr('alt', 'Map of the US showing FedEx Ground and FedEx Home Delivery transit times by region, ranging from 1 to 6 days depending on distance from the shipping origin. See the shipping transit time table above for exact times by state.');
	          jQuery('img[src="https://cdn.shopify.com/s/files/1/0228/2629/files/PriorityMail_grande.jpg?12534"]').attr('alt', 'Map of the contiguous US showing USPS Priority Mail transit times, ranging from 1 to 3 days depending on distance from the shipping origin in Southern California. See the shipping transit time table above for exact times by state.');
	          jQuery('img[src="https://cdn.shopify.com/s/files/1/0228/2629/files/ups-transit-map_grande.jpg?12538"]').attr('alt', 'Map of the US showing USPS First Class transit times, ranging from 1 to 6 days depending on distance from the shipping origin. See the shipping transit time table above for exact times by state.');
            jQuery('img[src*="basedinsocal.png"]').attr('alt','Angelus Direct manufacturing facility with production equipment and employees filling product containers.');
            jQuery('img[src*="history_photo.jpg"]').attr('alt',"Historical black-and-white photograph of three men standing in front of the Angelus workshop, representing the company's early leadership and origins.");
            
            jQuery('#shopify-section-template--19364343480386__main h3').attr('role','heading');
            jQuery('#shopify-section-template--19364343480386__main h3').attr('aria-level','2');
            jQuery('.GleamEmbedmAq5O.e-widget-preloader .e-widget-footer a').attr('aria-label','Powered by Gleam, opnes in new tab');
            jQuery('.GleamEmbedmAq5O.e-widget-preloader svg').attr('aria-hidden','true');
            jQuery('#shopify-section-template--19364343382082__main h1').attr('aria-level','2');
            jQuery('#shopify-section-template--19364343382082__main h1').attr('role','heading');
            jQuery('#mbcBundleItemsWidget').attr('role','region');
            jQuery('#mbcBundleItemsWidget').attr('aria-label','Frequently bought together');
            jQuery('.jdgm-medals__container').attr('role','list');
            jQuery('.jdgm-medals__container').attr('aria-label','Customer recognition and verification badges');
            jQuery('.jdgm-medals__container .jdgm-medal-wrapper').attr('role','listitem');
            jQuery('.jdgm-medals__container .jdgm-medal-wrapper').removeAttr('title');
            jQuery('svg').attr('aria-hidden','true');

     
            

            $('.jdgm-medal').each(function () {
            var $medal = $(this);
            var value = $medal.find('.jdgm-medal__value').text().trim();
            var label = $medal.attr('aria-label');

            if (value && label) {
                $medal.attr('aria-label', label + ', ' + value + ' verified reviews');
              }
            });


            $('.grid.md\\:grid-cols-4 > div[role="link"]').each(function () {
              var title = $(this).find('h3').first().text().trim();
              var description = $(this).find('p').first().text().trim();

              if (title) {
                  $(this).attr('aria-label', title + (description ? ' — ' + description : ''));
              }
            });
            
            
            jQuery('[class^="video-heading-template--"] > p').each(function(){
                jQuery(this).replaceWith(jQuery('<h2>',{
                    class:this.className,
                    html:jQuery(this).html()
                }));
             });
            
            var $section = $('#shopify-section-sections--19364336336962__1719497101bce8b3d0');
                var $main = $('main, [role="main"]').first();

                if ($section.length && $main.length) {
                    $section.appendTo($main);
                }

            jQuery('.flex.flex-wrap.items-center.type__nav.w-full')
                .attr({
                    'role': 'navigation',
                    'aria-label': 'Main navigation'
                });
        

            jQuery('nav').first().attr({
            'role': 'presentation',
            'aria-label': null
            });


            jQuery('a[href*="/collections/"]').each(function () {

                var $img = jQuery(this).find('img');

                if (
                    $img.length &&
                    (!$img.attr('alt') || jQuery.trim($img.attr('alt')) === '')
                ) {

                    var title = jQuery(this)
                        .find('.type__heading')
                        .first()
                        .text()
                        .trim();

                    if (title) {
                        $img.attr('alt', title + ' collection');
                    }
                }

            });


          


            function updateCartDialog() {
                  $('.occ3-display-block').each(function () {
                      $(this)
                          .attr('role', 'dialog')
                          .attr('aria-modal', 'true')
                          .attr('aria-label', 'Your cart');
                         
                  });
              }

              // Initial check
              updateCartDialog();

              // Watch for class changes and new elements
              const observer = new MutationObserver(function () {
                  updateCartDialog();
              });

              observer.observe(document.body, {
                  childList: true,
                  subtree: true,
                  attributes: true,
                  attributeFilter: ['class']
              });


                $(document).ready(function () {
                    const $main = $('main').first();

                    // Only add an H1 if one does not already exist on the page
                    if ($main.length && $('h1').length === 0) {
                        const pageTitle = document.title;

                        $main.prepend(
                            '<h1 class="sr-only">' + pageTitle + '</h1>'
                        );
                    }
                });


              jQuery('.product-grid-item-price').each(function () {

                    // Add Sale Price label
                    jQuery(this).find('pre, > div > span[x-html]').first().before(
                        '<span class="sr-only">Sale Price: </span>'
                    );

                    // Add Regular Price label
                    jQuery(this).find('s').each(function () {
                        if (!jQuery(this).prev('.sr-only').length) {
                            jQuery(this).before('<span class="sr-only">Regular Price: </span>');
                        }
                    });

                });


                // jQuery('#back-to-top').on('click', function (e) {
                //       e.preventDefault();

                //       jQuery('html, body').animate({
                //           scrollTop: 0
                //       }, 500, function () {

                //           const $target = jQuery('header a').first();

                //           if ($target.length) {
                //              //  $target.trigger('focus');
                //           }
                //       });
                //   });

                $('#back-to-top').on('click', function (e) {
                      e.preventDefault();

                      var moveFocus = keyboardActivated;
                      keyboardActivated = false;

                      $('html, body').animate({
                          scrollTop: 0
                      }, 500, function () {

                          if (moveFocus) {
                              var $target = $('header nav a').first();

                              if ($target.length) {
                                  $target.trigger('focus');
                              }
                          }

                      });
                  });

                  var $backToTop = $('#back-to-top');

                    // Keep hidden when page initially loads
                    $backToTop.removeClass('is-visible');

                    $(window).on('scroll', function () {

                        if ($(this).scrollTop() > 500) {
                            $backToTop.addClass('is-visible');
                        } else {
                            $backToTop.removeClass('is-visible');
                        }

                    });


                  jQuery(window).on('scroll', function () {
                        if (jQuery(this).scrollTop() > 300) {
                            jQuery('#back-to-top').fadeIn();
                        } else {
                            jQuery('#back-to-top').fadeOut();
                        }
                    });



                  jQuery(function () {
                        jQuery('#shop-hcaptcha-badge-container').hide();

                        const observer = new MutationObserver(function () {
                            jQuery('#shop-hcaptcha-badge-container').hide();
                        });

                        observer.observe(document.body, {
                            childList: true,
                            subtree: true
                        });
                    });


                  

           

                



                    

        }, 1500);


  
//=================================================  delayed code for 5 second for third party apps. =========================================================================================

  setTimeout(function(){ 
     jQuery('#occ3-drawer').attr('role','region');
      jQuery('#occ3-drawer').attr('aria-label','Your cart');
      jQuery('.collabs-page__images img').attr('alt','');
      
     },
  5000); 
//=================================================  accordion accessible for product page  =========================================================================================

  jQuery(function($){
      function makeAccordionsAccessible(){
          $('.accordion-content').each(function(index){
              var $panel=$(this);
              var $wrapper=$panel.parent();
              var $button=$wrapper.children('button').first();
              if(!$button.length)return;
              var buttonId='accordion-button-'+index;
              var panelId='accordion-panel-'+index;
              $button.attr({
                  'id':buttonId,
                  'aria-controls':panelId
              });
              $panel.attr({
                  'id':panelId,
                  'role':'region',
                  'aria-labelledby':buttonId
              });
              if(!$button.parent().is('h2')){
                  $button.wrap('<h2 class="accordion-heading"></h2>');
              }
              function updateState(){
                  var isOpen=$panel.is(':visible');
                  $button.attr('aria-expanded',isOpen?'true':'false');
              }
              updateState();
              new MutationObserver(updateState).observe($panel[0],{
                  attributes:true,
                  attributeFilter:['style','class']
              });
              $button.on('click',function(){
                  setTimeout(updateState,50);
              });
          });
      }
      makeAccordionsAccessible();
  });

  $(document).ready(function(){ 
      setTimeout(function(){ 
      
                  
              jQuery('.spurit-ni-button.spurit-ni-button-left').attr("aria-label","Decrease Product Quantity");
              jQuery('.spurit-ni-button.spurit-ni-button-right').attr("aria-label","Increase Product Quantity");
              jQuery('.occ3-quantity').attr("aria-label","Quantity");
              jQuery('.spurit-occ3__carousel-arrow spurit-occ3__carousel-arrow_left').attr("aria-label","Previous frequently purchased together item'");
              jQuery('.spurit-occ3__carousel-arrow spurit-occ3__carousel-arrow_right').attr("aria-label","Next frequently purchased together item'");
              jQuery('.btn.btn--load.btn--plain.btn--small').attr("aria-label","Product loading");
              jQuery('.btn.btn--load.btn--plain.btn--small').attr("aria-hidden","true");
              jQuery('.spurit-occ3__order-notes-textarea').attr("aria-label","Special instructions? Got it. Or leave a fun joke for your packer to enjoy.");
              jQuery('.spurit-occ3-saved-amount').css("color","#148500");
              jQuery('img.hs-lazyload.hs-id-a27d0277').attr('alt','');
              
        
              jQuery('.spurit-occ3__product-card-row').each(function(){
                var title=jQuery(this).find('.spurit-occ3__item-title').first().text().trim();
                var $thumbnail=jQuery(this).find('a.spurit-occ3__thumbnail').first();
                if(title && $thumbnail.length){
                    $thumbnail.attr('aria-label',title);
                }
              });

              // ==============================  Review section tab creation "jdgm-subtabe" ================================================================================

              jQuery(function($){
                  var $tablist=$('.jdgm-subtab');
                  var $tabs=$tablist.find('.jdgm-subtab__name');
                  $tablist.attr({'role':'tablist','aria-label':'Reviews and questions'});
                  $tabs.each(function(index){
                      var $tab=$(this);
                      var active=$tab.hasClass('jdgm--active');
                      var name=$tab.attr('data-tabname');
                      $tab.attr({
                          'role':'tab',
                          'id':'jdgm-tab-'+name,
                          'aria-selected':active?'true':'false',
                          'aria-controls':'jdgm-panel-'+name,
                          'tabindex':active?'0':'-1'
                      });
                  });
                  function updateTabs(){
                      $tabs.each(function(){
                          var $tab=$(this);
                          var active=$tab.hasClass('jdgm--active');
                          $tab.attr({
                              'aria-selected':active?'true':'false',
                              'tabindex':active?'0':'-1'
                          });
                      });
                  }
                  $tabs.on('click',function(){
                      setTimeout(updateTabs,50);
                  });
                  $tabs.on('keydown',function(e){
                      var index=$tabs.index(this);
                      var newIndex;
                      if(e.key==='ArrowRight'){
                          newIndex=(index+1)%$tabs.length;
                      }else if(e.key==='ArrowLeft'){
                          newIndex=(index-1+$tabs.length)%$tabs.length;
                      }else if(e.key==='Home'){
                          newIndex=0;
                      }else if(e.key==='End'){
                          newIndex=$tabs.length-1;
                      }else{
                          return;
                      }
                      e.preventDefault();
                      $tabs.eq(newIndex).focus().trigger('click');
                  });
                  new MutationObserver(updateTabs).observe($tablist[0],{
                      subtree:true,
                      attributes:true,
                      attributeFilter:['class']
                  });
              });

            
      },
    5000); 
  });



// ==============================  Made Play/pause video accessible for keybaord and screen reader for testimonial page ================================================================================





  jQuery(function ($) {
    var $buttons = $('div[class*="video-social-action-template--19364343676994__ss_video_grid_socials_3_"]');
    var $allVideos = $('[class*="video-social-video-template--19364343676994__ss_video_grid_socials_3_"] video');

    // Only one video plays at a time across all rows.
    // Clicking the OTHER video's own button (instead of calling .pause() directly)
    // ensures its play/pause icon and aria-label stay in sync too.
    $allVideos.on('play.a11y-singleplay', function () {
      var current = this;
      $allVideos.not(current).each(function () {
        if (!this.paused) {
          var $otherCard = $(this).closest('[class*="video-social-card-template--19364343676994__ss_video_grid_socials_3_"]');
          var otherBtn = $otherCard.find('[class*="video-social-action-template--19364343676994__ss_video_grid_socials_3_"]')[0];
          if (otherBtn) {
            otherBtn.click();
          } else {
            this.pause();
          }
        }
      });
    });

    $buttons.each(function () {
      var $btn = $(this);
      var $card = $btn.closest('[class*="video-social-card-template--19364343676994__ss_video_grid_socials_3_"]');
      var $video = $card.find('video');

      var handle = $card
        .find('p[class*="video-social-info-template--19364343676994__ss_video_grid_socials_3_"]')
        .first()
        .text()
        .trim()
        .replace(/^@/, '');

      var $sliderContainer = $btn.closest('[class*="video-social-slider-template--19364343676994__ss_video_grid_socials_3_"]');
      var swiperInstance = $sliderContainer.length ? $sliderContainer[0].swiper : null;
      if (swiperInstance && swiperInstance.params && swiperInstance.params.a11y) {
        swiperInstance.params.a11y.scrollOnFocus = false;
      }

      function updateLabel() {
        var paused = $video.length ? $video[0].paused : true;
        var action = paused ? 'Play' : 'Pause';
        var label = handle ? (action + ' video of ' + handle) : (action + ' video');
        $btn.attr('aria-label', label);
      }

      $btn.attr({ role: 'button', tabindex: '0' });
      updateLabel();

      $video.on('play.a11y pause.a11y', updateLabel);

      $btn.on('keydown.a11y', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar' || e.keyCode === 13 || e.keyCode === 32) {
          e.preventDefault();
          this.click();
          updateLabel();
        }
      });

      $btn.on('focus.a11y', function () {
        $(this).css('outline', '2px solid #005fcc');
      }).on('blur.a11y', function () {
        $(this).css('outline', '');
      });
    });
  });




//================================================= Made pdfs link accessible for color-chart page  =========================================================================================


  (function ($) {
    function humanizeFilename(url) {
      try {
        var path = url.split('?')[0];
        var filename = decodeURIComponent(path.substring(path.lastIndexOf('/') + 1));
        var ext = (filename.split('.').pop() || '').toLowerCase();
        var name = filename.replace(/\.[^/.]+$/, '');
        // strip trailing UUID suffixes Shopify appends on re-upload
        name = name.replace(/_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, '');
        name = name.replace(/_copy$/i, '').replace(/[_-]+/g, ' ').trim();
        return { name: name, ext: ext };
      } catch (e) {
        return { name: 'document', ext: '' };
      }
    }

    function extractUrl($el) {
      var clickAttr = $el.attr('@click') || '';
      var match = clickAttr.match(/document\.location\.href\s*=\s*'([^']+)'/);
      return match ? match[1] : null;
    }

    function initAccessibleFileCards() {
      $('[\\@click*="document.location.href"]').each(function () {
        var $card = $(this);
        if ($card.data('a11y-file-fixed')) return;

        var url = extractUrl($card);
        if (!url) return;

        var $heading = $card.find('h2').first();
        var headingText = $heading.length ? $heading.text().trim() : '';
        var info = humanizeFilename(url);
        var subject = headingText || info.name; // falls back to filename for the swatch cards, which have no <h2>

        var fileTypeLabel = info.ext === 'pdf' ? 'PDF' : (info.ext ? info.ext.toUpperCase() + ' image' : 'file');
        var label = subject + ' — ' + fileTypeLabel + ', opens in new tab';

        $card.attr({
          role: 'link',
          tabindex: '0',
          'aria-label': label
        });

        $card.removeAttr('@click'); // remove the inaccessible same-tab Alpine navigation

        function openInNewTab() {
          var win = window.open(url, '_blank', 'noopener,noreferrer');
          if (win) win.opener = null;
        }

        $card.on('click', function (e) {
          e.preventDefault();
          openInNewTab();
        });

        $card.on('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openInNewTab();
          }
        });

        $card.data('a11y-file-fixed', true);
      });
    }

    $(document).ready(initAccessibleFileCards);

    var observer = new MutationObserver(function () {
      initAccessibleFileCards();
    });
    $(document).ready(function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  })(jQuery);

//================================================= tabs in video page  =========================================================================================

  (function ($) {
    function initAccessibleTabs() {
      // Match all three tab groups by their shared naming convention
      $('[class*="video-tabs-list-template--"]').each(function () {
        var $tablist = $(this);

        // 1. Ensure the container has role="tablist"
        if (!$tablist.attr('role')) {
          $tablist.attr('role', 'tablist');
        }

        var $tabs = $tablist.find('label[class*="video-tab-template--"]');

        // 2. Ensure every tab has role, tabindex, aria-selected, and a stable id
        $tabs.each(function (i) {
          var $tab = $(this);
          var isActive = $tab.hasClass('active');

          if (!$tab.attr('role')) $tab.attr('role', 'tab');
          if (!$tab.attr('id')) {
            $tab.attr('id', $tab.closest('[class*="video-tabs-list-template--"]').attr('id') ||
              'vtab-' + Math.random().toString(36).slice(2, 9) + '-' + i);
          }
          $tab.attr({
            tabindex: isActive ? '0' : '-1',
            'aria-selected': isActive ? 'true' : 'false'
          });
        });

        // 3. Sync aria-selected/tabindex whenever .active changes on ANY tab in
        //    this group — regardless of whether it was our click handler, the
        //    theme's own JS, or a third-party app that moved it.
        var observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (m) {
            if (m.attributeName === 'class') {
              var $changed = $(m.target);
              var active = $changed.hasClass('active');
              $changed.attr({
                tabindex: active ? '0' : '-1',
                'aria-selected': active ? 'true' : 'false'
              });
            }
          });
        });
        $tabs.each(function () {
          observer.observe(this, { attributes: true, attributeFilter: ['class'] });
        });

        // 4. Click: let the theme's existing handler do its content swap.
        //    We only need to guarantee focus lands correctly for keyboard users.
        $tabs.on('click', function () {
          // No manual class/attr toggling here — the MutationObserver (step 3)
          // picks up whatever the theme's click handler changes.
        });

        // 5. Keyboard support per the APG Tabs pattern (labels have no native
        //    key handling, so this is required, not optional).
        $tabs.on('keydown', function (e) {
          var idx = $tabs.index(this);
          var newIdx = null;

          switch (e.key) {
            case 'ArrowRight':
            case 'ArrowDown':
              newIdx = (idx + 1) % $tabs.length;
              break;
            case 'ArrowLeft':
            case 'ArrowUp':
              newIdx = (idx - 1 + $tabs.length) % $tabs.length;
              break;
            case 'Home':
              newIdx = 0;
              break;
            case 'End':
              newIdx = $tabs.length - 1;
              break;
            case 'Enter':
            case ' ':
              e.preventDefault();
              // Dispatch a real click so any handler bound directly to this
              // node (theme JS, third-party app) fires exactly as if clicked
              // with a mouse.
              this.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
              return;
            default:
              return; // let all other keys behave normally
          }

          e.preventDefault();
          var $next = $tabs.eq(newIdx);
          $next.trigger('focus');
          $next[0].dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
        });
      });
    }

    $(document).ready(initAccessibleTabs);

    // Re-run if the section re-renders (e.g. Shopify section re-render on
    // theme editor changes, or an app re-injecting the block)
    var sectionObserver = new MutationObserver(function () {
      initAccessibleTabs();
    });
    $(document).ready(function () {
      var target = document.querySelector('[class*="video-tabs-list-template--"]')?.closest('section, .shopify-section');
      if (target) {
        sectionObserver.observe(target, { childList: true, subtree: false });
      }
    });
  })(jQuery);



//================================================= active email and phone  =========================================================================================

  // jQuery('*').contents().filter(function(){
  //     return this.nodeType===3&&this.nodeValue.includes('+18334611424');
  // }).each(function(){
  //     jQuery(this).replaceWith(this.nodeValue.replace('+18334611424','<a href="tel:+18334611424" aria-label="Call Angelus Direct at +1 833 461 1424">+18334611424</a>'));
  // });

  // jQuery('*').contents().filter(function(){
  //     return this.nodeType===3&&this.nodeValue.includes('info@angelusdirect.com');
  // }).each(function(){
  //     jQuery(this).replaceWith(this.nodeValue.replace('info@angelusdirect.com','<a href="mailto:info@angelusdirect.com" aria-label="Email Angelus Direct at info@angelusdirect.com">info@angelusdirect.com</a>'));
  // });


  // Fix 2: skip text nodes that are the ONLY child of their parent (i.e. would become
  // a bare top-level <a> once replaced) — wrap in a neutral inline element instead
  jQuery('*').contents().filter(function(){
      return this.nodeType === 3 && this.nodeValue.includes('+18334611424');
  }).each(function(){
      var $parent = jQuery(this).parent();
      var isOnlyChild = $parent.contents().length === 1;
      var replacementHtml = this.nodeValue.replace(
        '+18334611424',
        '<a href="tel:+18334611424" aria-label="Call Angelus Direct at +1 833 461 1424">+18334611424</a>'
      );

      if (isOnlyChild && $parent.is('p, div, li, h1, h2, h3, h4, h5, h6') === false) {
        // parent isn't already a safe block wrapper — insert one so <a> never sits at top level
        jQuery(this).replaceWith('<p class="sr-only-inline">' + replacementHtml + '</p>');
      } else {
        jQuery(this).replaceWith(replacementHtml);
      }
  });

    // Fix 1: only wrap if .ada-phone/.ada-email is an inline element, not a block-level root
      jQuery('.ada-phone').each(function () {
        var $el = jQuery(this);
        if ($el.is('p, div, li, h1, h2, h3, h4, h5, h6')) {
          // it's a block-level top node — wrap the CONTENT, not the element itself
          $el.wrapInner('<a href="tel:+15623258096" aria-label="Call Angelus Direct at +1 562 325 8096"></a>');
        } else {
          $el.wrap('<a href="tel:+15623258096" aria-label="Call Angelus Direct at +1 562 325 8096"></a>');
        }
      });

      jQuery('.ada-email').each(function () {
        var $el = jQuery(this);
        var mailLabel = 'Send an email to info@angelusdirect.com';
        if ($el.is('p, div, li, h1, h2, h3, h4, h5, h6')) {
          $el.wrapInner('<a href="mailto:info@angelusdirect.com" aria-label="' + mailLabel + '"></a>');
        } else {
          $el.wrap('<a href="mailto:info@angelusdirect.com" aria-label="' + mailLabel + '"></a>');
        }
      });

//=================================================  update error msg  =========================================================================================


  jQuery(function($){
      var $form=$('#comment_form');
      var $name=$form.find('input[name="comment[author]"]');
      var $email=$form.find('input[name="comment[email]"]');
      var $comment=$form.find('textarea[name="comment[body]"]');
      $name.on('invalid',function(){
          this.setCustomValidity('Please enter your name.');
      });
      $email.on('invalid',function(){
          if(this.validity.valueMissing){
              this.setCustomValidity('Please enter your email address.');
          }else if(this.validity.typeMismatch){
              this.setCustomValidity('Please enter a valid email address.');
          }
      });
      $comment.on('invalid',function(){
          this.setCustomValidity('Please enter your comment.');
      });
      $name.add($email).add($comment).on('input',function(){
          this.setCustomValidity('');
      });
  });


//=================================================  add aria-label to share social media link on news post  =========================================================================================

  jQuery('.SocialShare').each(function(){
      var $link=jQuery(this);
      var href=$link.attr('href')||'';
      var slug=window.location.pathname.split('/').filter(Boolean).pop()||'this page';
      var pageName=decodeURIComponent(slug).replace(/-/g,' ');
      if(href.includes('facebook.com')){
          $link.attr('aria-label','Share '+pageName+' on Facebook (opens in a new tab)');
      }else if(href.includes('twitter.com')||href.includes('x.com')){
          $link.attr('aria-label','Share '+pageName+' on X (opens in a new tab)');
      }else if(href.includes('pinterest.com')){
          $link.attr('aria-label','Share '+pageName+' on Pinterest (opens in a new tab)');
      }
  });


//=================================================  hide hidden content from the screen reader product page "Fullscreen popup" =========================================================================================


  jQuery(function($){
      $('section[x-ref="fullscreen_container"]').each(function(){
          var popup=this;
          var $popup=$(popup);
          function updatePopup(){
              var opacity=parseFloat($popup.css('opacity'));
              var pointerEvents=$popup.css('pointer-events');
              var isClosed=opacity===0||pointerEvents==='none';
              if(isClosed){
                  $popup.attr('aria-hidden','true');
                  popup.inert=true;
              }else{
                  $popup.removeAttr('aria-hidden');
                  popup.inert=false;
              }
          }
          updatePopup();
          new MutationObserver(updatePopup).observe(popup,{
              attributes:true,
              attributeFilter:['style']
          });
      });
  });



//================================================= Increase/decrease button accessible using Enter key =========================================================================================

    (function ($) {
      $(function () {

        function enhanceQuantityButtons($scope) {
          $scope.find('.quantity-block-button').each(function () {
            var $btn = $(this);
            if ($btn.data('a11yEnterFixed')) return;
            $btn.data('a11yEnterFixed', true);

            function activate() {
              if (this.disabled) return;
              this.click();
              // Re-focus this exact button after Alpine's re-render settles,
              // in case the click handler causes a DOM update that knocks focus off
              var self = this;
              setTimeout(function () {
                if (document.body.contains(self) && !self.disabled) {
                  self.focus();
                }
              }, 60);
            }

            $btn.on('keydown', function (e) {
              if (e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                activate.call(this);
              }
            });

            $btn.on('click', function () {
              // Also catch mouse clicks, in case focus drifts there too
              var self = this;
              setTimeout(function () {
                if (document.body.contains(self) && !self.disabled) {
                  self.focus();
                }
              }, 60);
            });
          });
        }

        enhanceQuantityButtons($(document));

        var domObserver = new MutationObserver(function (mutations) {
          mutations.forEach(function (m) {
            m.addedNodes.forEach(function (node) {
              if (node.nodeType !== 1) return;
              var $node = $(node);
              if ($node.is('.quantity-block-button')) enhanceQuantityButtons($node.parent());
              enhanceQuantityButtons($node);
            });
          });
        });
        domObserver.observe(document.body, { childList: true, subtree: true });

      });
    })(jQuery);





  $(document).on('click', '.quantity-block-button', function () {
    var btn = this;

    function restoreFocus() {
      if (!btn.disabled) {
        btn.focus();
      } else {
        requestAnimationFrame(restoreFocus);
      }
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(restoreFocus);
    });
  });




//================================================= made product option of "Select size" dialog box accessible =========================================================================================

  (function ($) {
    $(function () {

      function enhanceOptionButton($btn) {
        if ($btn.data('a11yRadioDone')) return;
        $btn.data('a11yRadioDone', true);

        var $group = $btn.closest('[x-data]');
        if (!$group.length) return;

        if (!$group.data('a11yRadioGroupDone')) {
          $group.data('a11yRadioGroupDone', true);
          $group.attr({ role: 'radiogroup', 'aria-label': 'Select size' });
        }

        $btn.attr('role', 'radio').removeAttr('aria-selected');

        function syncChecked() {
          var isSelected = $btn.hasClass('border--focus');
          $btn.attr('aria-checked', isSelected ? 'true' : 'false');
          $btn.attr('tabindex', isSelected ? '0' : '-1');
        }
        syncChecked();

        var observer = new MutationObserver(syncChecked);
        observer.observe($btn[0], { attributes: true, attributeFilter: ['class'] });
      }

      // --- Watch the whole document for dialogs/modals injecting these buttons ---
      var domObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return; // only element nodes
            var $node = $(node);

            if ($node.is('.product-option-button')) {
              enhanceOptionButton($node);
            }
            $node.find('.product-option-button').each(function () {
              enhanceOptionButton($(this));
            });
          });
        });
      });
      domObserver.observe(document.body, { childList: true, subtree: true });

      // Also catch any that are already present at page load, just in case
      $('.product-option-button').each(function () {
        enhanceOptionButton($(this));
      });

      // --- Delegated keyboard handling — works regardless of when the button appears ---
      $(document).on('keydown', '.product-option-button', function (e) {
        var $btn = $(this);
        var $group = $btn.closest('[x-data]');
        var $allInGroup = $group.find('.product-option-button');
        var idx = $allInGroup.index(this);
        var next;

        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          next = $allInGroup.eq((idx + 1) % $allInGroup.length);
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          next = $allInGroup.eq((idx - 1 + $allInGroup.length) % $allInGroup.length);
        } else if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
          return;
        }

        if (next && next.length) {
          next.trigger('focus');
          next[0].click();
        }
      });

    });
  })(jQuery);

//================================================= aria-hidden on Works Great On =========================================================================================

  (function ($) {
    $(function () {

      $('[x-ref="slider"]').each(function () {
        var sliderEl = this;
        // Flickity applies overflow:hidden to .flickity-viewport — that's the
        // real visible clipping boundary, not necessarily this element itself
        var viewportEl = sliderEl.closest('.flickity-viewport') ||
                          sliderEl.querySelector('.flickity-viewport') ||
                          sliderEl;

        function applyA11y(slideEl, isVisible) {
          var desired = isVisible ? 'false' : 'true';
          if (slideEl.getAttribute('aria-hidden') !== desired) {
            slideEl.setAttribute('aria-hidden', desired);
          }

          var $slide = $(slideEl);
          var $titleLink = $slide.find('a').filter(function () {
            return $(this).find('h2, h3').length > 0;
          });
          var $imageLink = $slide.find('a').not($titleLink);

          $imageLink.attr('tabindex', '-1');

          if (isVisible) {
            $titleLink.removeAttr('tabindex');
          } else {
            $titleLink.attr('tabindex', '-1');
          }
        }

        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            // Require a meaningful chunk of the slide to be visible (not
            // just 1px of an edge peeking in) before treating it as "shown"
            applyA11y(entry.target, entry.intersectionRatio > 0.15);
          });
        }, {
          root: viewportEl,
          threshold: [0, 0.15, 0.5, 1]
        });

        $(sliderEl).find('[data-slide]').each(function () {
          io.observe(this);
        });
      });

    });
  })(jQuery);

//================================================= Best Selling Kits slider seprate review and product name  ===========================================================================================

  (function ($) {
    $(function () {

      function updateCarouselA11y($slider, observer) {
        if (observer) observer.disconnect();

        var sliderRect = $slider[0].getBoundingClientRect();

        $slider.find('[data-slide]').each(function () {
          var $slide = $(this);
          var slideRect = this.getBoundingClientRect();

          // Visibility = does this card actually overlap the slider's visible viewport,
          // not Flickity's single "selected" index (this carousel shows several cards at once)
          var isVisible = slideRect.right > sliderRect.left && slideRect.left < sliderRect.right;

          // Sync aria-hidden to real visual state — only write if it would actually change
          var desiredValue = isVisible ? 'false' : 'true';
          if ($slide.attr('aria-hidden') !== desiredValue) {
            $slide.attr('aria-hidden', desiredValue);
          }

          // Image link and title link both point to the same product — only the
          // title link (the one containing an <h2>) should ever be tab-reachable
          var $titleLink = $slide.find('a').filter(function () {
            return $(this).find('h2').length > 0;
          });
          var $imageLink = $slide.find('a').not($titleLink);

          $imageLink.attr('tabindex', '-1'); // always excluded, regardless of visibility

          if (isVisible) {
            $titleLink.removeAttr('tabindex');
          } else {
            $titleLink.attr('tabindex', '-1');
          }

          // Quick Add button, if present, follows the same visibility rule
          var $quickAdd = $slide.find('button').not('[data-occ3], [data-editable]');
          if (isVisible) {
            $quickAdd.each(function () {
              if ($(this).attr('tabindex') === '-1') $(this).removeAttr('tabindex');
            });
          } else {
            $quickAdd.attr('tabindex', '-1');
          }
        });

        if (observer) {
          observer.observe($slider[0], {
            attributes: true,
            attributeFilter: ['aria-hidden'],
            subtree: true
          });
        }
      }

      $('[x-ref="slider"]').each(function () {
        var $slider = $(this);
        var sliderEl = this;

        var observer = new MutationObserver(function () {
          updateCarouselA11y($slider, observer);
        });

        // Initial pass — no observer connected yet, nothing to disconnect
        updateCarouselA11y($slider, null);

        observer.observe(sliderEl, {
          attributes: true,
          attributeFilter: ['aria-hidden'],
          subtree: true
        });

        sliderEl.addEventListener('select.flickity', function () {
          updateCarouselA11y($slider, observer);
        });

        // Cards scroll in/out gradually via drag or the arrow buttons —
        // debounced scroll listener catches those continuous changes
        var scrollDebounce;
        sliderEl.addEventListener('scroll', function () {
          clearTimeout(scrollDebounce);
          scrollDebounce = setTimeout(function () {
            updateCarouselA11y($slider, observer);
          }, 100);
        });
      });


      // ── Separate: review widget de-nesting ──────────────────────────
      // (Independent of visibility — runs once, not tied to scroll/observer)
      $('a.card--product-item__content').each(function () {
        var $link = $(this);
        var $reviewWidget = $link.find('.jdgm-widget').first();

        if ($reviewWidget.length) {
          $reviewWidget.insertAfter($link);

          var $starsSpan = $reviewWidget.find('.jdgm-prev-badge__stars');
          $starsSpan.removeAttr('role').removeAttr('tabindex').attr('aria-hidden', 'true');

          var rating = $reviewWidget.find('.jdgm-prev-badge').attr('data-average-rating');
          var count  = $reviewWidget.find('.jdgm-prev-badge').attr('data-number-of-reviews');
          if (rating && count) {
            $reviewWidget.attr('aria-label', rating + ' out of 5 stars, ' + count + ' reviews');
          }
        }
      });

    });
  })(jQuery);






//================================================= Mega menu accessible using keyboard ===========================================================================================

  (function ($) {
    $(function () {

      function forceStyle(el, styles) {
        Object.keys(styles).forEach(function (prop) {
          el.style.setProperty(prop, styles[prop], 'important');
        });
      }

      function setClosed($dropdown) {
        forceStyle($dropdown[0], {
          'height': '0',
          'opacity': '0',
          'overflow': 'hidden',
          'visibility': 'hidden',
          'pointer-events': 'none'
        });
      }

      function setOpen($dropdown) {
        forceStyle($dropdown[0], {
          'height': 'auto',
          'opacity': '1',
          'overflow': 'visible',
          'visibility': 'visible',
          'pointer-events': 'auto'
        });
      }

      var $navItems = $('.header__link').filter(function () {
        return $(this).siblings('.header__dropdown').length > 0;
      });

      var $allDropdowns = $navItems.map(function () {
        return $(this).siblings('.header__dropdown').first()[0];
      });

      // Force every dropdown closed on load, overriding the theme's default CSS
      $allDropdowns.each(function () { setClosed($(this)); });

      function closeAllMenus() {
        $allDropdowns.each(function () {
          var $d = $(this);
          setClosed($d);
          $d.attr('aria-hidden', 'true');
        });
        $('.header__menu-toggle').each(function () {
          var $btn = $(this);
          $btn.attr('aria-expanded', 'false');
          setArrowRotation($btn, false);
      });
        $('.header__menu-toggle[aria-expanded="true"]').attr('aria-expanded', 'false');
      }

      function openMenu($dropdown, $toggleBtn) {
        closeAllMenus();
        setOpen($dropdown);
        $dropdown.attr('aria-hidden', 'false');
        $toggleBtn.attr('aria-expanded', 'true');
        setArrowRotation($toggleBtn, true);

      }

      $navItems.each(function (i) {
        var $link = $(this);
        var $wrapper = $link.closest('.flex-shrink');
        var $dropdown = $link.siblings('.header__dropdown').first();
        var dropdownId = 'header-dropdown-' + i;
        var toggleId = 'header-menu-toggle-' + i;
        var label = $.trim($link.clone().children().remove().end().text());
        var $chevron = $link.find('> span[aria-hidden="true"]').first();

        $dropdown.attr({ id: dropdownId, 'aria-hidden': 'true' });

        var $toggleBtn = $('<button type="button" class="header__menu-toggle"></button>')
          .addClass($chevron.attr('class') || '')
          .attr({
            id: toggleId,
            'aria-haspopup': 'true',
            'aria-expanded': 'false',
            'aria-controls': dropdownId,
            'aria-label': 'Show ' + label + ' menu'
          })
          .append($chevron.length ? $chevron.contents().clone(true, true) : '');

          $chevron.remove();

          var $row = $('<span class="header__nav-item-inner"></span>').css({
          display: 'inline-flex',
          'align-items': 'center'
          });
          

          $link.before($row);
          $row.append($link).append($toggleBtn);

        $toggleBtn.on('click', function (e) {
          e.stopPropagation();
          var isOpen = $dropdown.attr('aria-hidden') === 'false';
          closeAllMenus();
          if (!isOpen) openMenu($dropdown, $toggleBtn);
        });

        $toggleBtn.on('keydown', function (e) {
          if (e.key === 'ArrowDown' || e.keyCode === 40) {
            e.preventDefault();
            openMenu($dropdown, $toggleBtn);
            $dropdown.find('a').first().trigger('focus');
          }
        });

        // Close only when focus truly leaves this nav item (link + toggle + open panel)
        $wrapper.on('focusout', function (e) {
          var goingTo = e.relatedTarget;
          if (!goingTo || !$wrapper[0].contains(goingTo)) {
            closeAllMenus();
          }
        });
      });


                                                            var menuCloseTimer = null;

                                            function cancelMenuClose() {
                                              clearTimeout(menuCloseTimer);
                                              menuCloseTimer = null;
                                            }

                                            function scheduleMenuClose(delay) {
                                              cancelMenuClose();
                                              menuCloseTimer = setTimeout(function () {
                                                closeAllMenus();
                                              }, delay || 250);
                                            }

                                            $('.header__nav-item-inner').each(function () {
                                              var $item = $(this);
                                              var $dropdown = $item.siblings('.header__dropdown').first();
                                              var $toggleBtn = $item.find('.header__menu-toggle').first();

                                              $item.add($dropdown).on('mouseenter', function () {
                                                cancelMenuClose();
                                                if (!$dropdown.hasClass('is-open')) {
                                                  openMenu($dropdown, $toggleBtn);
                                                  setArrowRotation($toggleBtn, true);
                                                }
                                              });

                                              $item.add($dropdown).on('mouseleave', function () {
                                                scheduleMenuClose(250);
                                              });
                                            });



      $(document).on('keydown', function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
          var $openToggle = $('.header__menu-toggle[aria-expanded="true"]');
          if ($openToggle.length) {
            closeAllMenus();
            $openToggle.first().trigger('focus');
          }
        }
      });

      $(document).on('click', function (e) {
        if (!$(e.target).closest('.header__dropdown, .header__menu-toggle').length) {
          closeAllMenus();
        }
      });

      function setArrowRotation($toggleBtn, isOpen) {
      var svg = $toggleBtn.find('svg')[0];
      if (!svg) return;
      svg.style.setProperty('transition', 'transform 0.2s ease', 'important');
      svg.style.setProperty('transform', isOpen ? 'rotate(180deg)' : 'rotate(0deg)', 'important');
  }

    });
  })(jQuery);

//============================================================================================================================================

  $(document).ready(function () {

    const altTextMap = [
      // ── Logo ──
      { match: 'Angelus_Direct_NEW_Logo', alt: 'Angelus Direct logo' },

      // ── Product Card Swatches (kit carousel) ──
      { match: 'Swatches_PYOC_2',      alt: 'Pick your own colors' },
      { match: 'Swatches_PYOC_1',      alt: 'Pick your own colors' },
      { match: 'Earsy_Cleane_Swatch',  alt: 'Color and finish swatch for Angelus Easy Cleaner Kit' },
      { match: 'Basics_Kit_Swatch',    alt: 'Get started painting' },
      { match: '12_Color_Kit_1',       alt: '12 color kit' },
      { match: 'Pearl_Kit_Swatch',     alt: 'Pearl_Kit_Swatch' },
      { match: 'Neon_Kit_Swatch',      alt: '12 color kit' },

      // ── "Trusted by Artists" category tiles ──
      { match: 'CustomIze-3',          alt: 'Customized sneakers painted with Angelus acrylic leather paint' },
      { match: 'easy_cleaner_',        alt: 'Angelus Easy Cleaner bottle for shoes and leather goods' },
      { match: 'Shine.jpg',            alt: 'Freshly polished leather shoes with Angelus shine products' },
      { match: 'Dye-4.jpg',            alt: 'Leather item dyed with Angelus leather dye' },

      // ── "Angelus Paint" feature icons ──
      { match: 'Flexible_Square',      alt: 'image representing flexible, non-cracking Angelus paint' },
      { match: 'Durable_Square',       alt: 'image representing durable, long-lasting Angelus paint' },
      { match: 'Versatile_Square',     alt: 'image representing versatile use of Angelus paint on multiple materials' },
      { match: 'Colorful_1',           alt: 'image representing 120+ vibrant Angelus paint color options' },

      // ── "Works Great On" material tiles ──
      { match: 'shoes_2a7fb42f',       alt: 'Pair of sneakers customized with Angelus paint' },
      { match: 'Bags_c2fe186f',        alt: 'Leather bag customized with Angelus paint' },
      { match: 'Furniture_c158db86',   alt: 'Furniture piece restored with Angelus paint' },
      { match: 'Guitrars_1',           alt: 'Guitar customized with Angelus paint' },
      { match: 'Waterbottles.jpg',     alt: 'Hydroflask water bottle painted with Angelus paint' },
      { match: 'skateboards_',         alt: 'Skateboard deck custom dyed and painted with Angelus products' },
      { match: 'Roller_Skates_',       alt: 'Roller skates custom painted with Angelus paint' },
      { match: 'clothes.jpg',          alt: 'Denim jeans custom painted with Angelus paint' },

      // ── Social icons ──
      { match: 'tik-tok',              alt: 'TikTok icon' },

      // ── Collection nav thumbnails ──
      { match: 'Low_VOC_Leather_Dye',  alt: 'Angelus Low VOC Leather Dye bottles in assorted vibrant colors' }
    ];

    // ── Apply alt text based on filename match ──
    let fixedCount = 0;
    let skippedCount = 0;

    $('img').each(function () {
      const $img = $(this);
      const src  = $img.attr('src') || $img.attr('data-src') || '';
      const currentAlt = $img.attr('alt');

      // Skip if alt already exists and is meaningful (not empty, not generic)
      const isMissingOrWeak = !currentAlt || currentAlt.trim() === '';

      if (isMissingOrWeak) {
        const match = altTextMap.find(function (item) {
          return src.includes(item.match);
        });

        if (match) {
          $img.attr('alt', match.alt);
          fixedCount++;
          console.log(`✅ Fixed: ${match.alt}`);
        } else {
          // Try smart fallback: nearby heading text
          const nearbyHeading = $img.closest('div, li, article')
            .find('h2, h3, h4').first().text().trim();

          if (nearbyHeading) {
            $img.attr('alt', nearbyHeading);
            fixedCount++;
            console.log(`✅ Fallback (heading): ${nearbyHeading}`);
          } else {
            // Last resort — mark as decorative rather than leave broken
            $img.attr('alt', '');
            skippedCount++;
            console.warn(`⚠️ No match — marked decorative: ${src.substring(0, 70)}`);
          }
        }
      }
    });

    console.log(`\n📊 WCAG Alt Text Audit Complete`);
    console.log(`Total images checked : ${$('img').length}`);
    console.log(`Fixed with real alt   : ${fixedCount}`);
    console.log(`Marked decorative     : ${skippedCount}`);

  });



jQuery('form[action="/search"] input').attr('aria-label','Search by products, colors, or more');

jQuery('.remodal-close').attr('aria-label', 'Close modal');






 


function applyAriaLabels() {
    const $closeBtn = jQuery('.spurit-occ3__btn.spurit-occ3__btn_plain');
    const $upsellClose = jQuery('.spurit-occ3__volume-upsell-close');

    if ($closeBtn.length && !$closeBtn.attr('aria-label')) {
        $closeBtn.attr('aria-label', 'Close cart');
    }
    if ($upsellClose.length && !$upsellClose.attr('aria-label')) {
        $upsellClose.attr('aria-label', 'Close upsell');
    }
}

// Run immediately in case elements already exist
applyAriaLabels();

// Watch for the app injecting these elements dynamically (common with cart upsell apps)
const observer = new MutationObserver(function () {
    applyAriaLabels();
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});




jQuery('.tpo-quantity_always-show .tpo_quantity-selector_input.tpo_').attr('aria-label', 'Quantity');
jQuery('form[action="/cart/add"] input').attr('aria-label', 'Quantity');
jQuery('.collection-bottom-description.mt-8 a:empty').remove();
jQuery('.window--wide h3:empty').remove();



//============================================================================================================================================


  jQuery(document).ready(function ($) {
      var tpoErrorIdCounter = 0;

      function makeQuantitySelectorAccessible($wrapper) {
          var $input = $wrapper.find('.tpo_quantity-selector_input');
          var $minus = $wrapper.find('.tpo_quantity-selector_minus');
          var $plus = $wrapper.find('.tpo_quantity-selector_plus');
          // In the given markup, the error message div is a SIBLING of the
          // wrapper (both children of .tpo-quantity_always-show), not a
          // descendant — so we go to the parent and find it there.
          var $error = $wrapper.parent().find('.tpo_error-message').first();

          // Name the input. aria-label deliberately doesn't rely on the
          // input's existing id (it's an unusual comma-joined GUID string)
          // and doesn't need to be unique, so it's safe even with several
          // quantity selectors on one page.
          if (!$input.attr('aria-label')) {
              $input.attr({
                  'aria-label': 'Quantity',
                  'inputmode': 'numeric' // better mobile keyboard; doesn't
                                          // touch `type`, so Tepo's own
                                          // value parsing/formatting JS
                                          // keeps working exactly as before
              });
          }

          // Turn the +/- spans into real, keyboard-operable controls
          // without touching whatever click handler Tepo's own script
          // already attached to them — we only add what's missing.
          [
              { $el: $minus, label: 'Decrease quantity' },
              { $el: $plus, label: 'Increase quantity' }
          ].forEach(function (item) {
              if (item.$el.length && !item.$el.attr('role')) {
                  item.$el.attr({
                      role: 'button',
                      tabindex: '0',
                      'aria-label': item.label
                  });
                  item.$el.on('keydown', function (e) {
                      if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          $(this).trigger('click'); // fires Tepo's existing
                                                    // click handler, same
                                                    // as a real mouse click
                      }
                  });
              }
          });

          // Make the error message an announced live region, and tie it to
          // the input via aria-describedby so screen readers associate the
          // error with this specific field once Tepo's JS fills it in.
          if ($error.length && !$error.attr('role')) {
              var errorId = $error.attr('id') || ('tpo-error-' + (tpoErrorIdCounter++));
              $error.attr({
                  id: errorId,
                  role: 'alert',
                  'aria-live': 'assertive',
                  'aria-atomic': 'true'
              });
              $input.attr('aria-describedby', errorId);
          }
      }

      function scanQuantitySelectors() {
          $('.tpo_quantity-selector_wrapper').each(function () {
              makeQuantitySelectorAccessible($(this));
          });
      }

      scanQuantitySelectors();

      // Tepo's conditional logic can show/hide or re-render option sets
      // (including this quantity stepper) after initial load — reapply
      // whenever matching markup shows up again.
      var tpoObserver = new MutationObserver(function () {
          scanQuantitySelectors();
      });
      tpoObserver.observe(document.body, { childList: true, subtree: true });
  });



